import React, { useEffect, useState, forwardRef } from "react";
import { Button, Form, InputGroup, Modal, Spinner } from "react-bootstrap";
import { s3FileManagerServices } from "../../../APIServices/SitePilotManagement/s3FileManagerServices";
import Swal from "sweetalert2";

const UpdateFolder = forwardRef(({ Show, Hide, Title, sourceKey, getTotalS3Folders, folderData, handleAddNewTab }, ref) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const [extension, setExtension] = useState("");

  const removeLastFolder = (path) => {
    const cleanPath = path.replace(/\/$/, "");
    return cleanPath.substring(0, cleanPath.lastIndexOf("/") + 1);
  };

  const updateS3Folder = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Rename!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Rename it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        const userData = {
          previousName: sourceKey?.[0],
        };
        if(extension){
          userData.currentName = `${removeLastFolder(sourceKey?.[0])}${name}.${extension}/`
        }else{
          userData.currentName = `${removeLastFolder(sourceKey?.[0])}${name}/`
        }
        const data = await s3FileManagerServices.updateS3Folder(userData);
        setButtonLoader(false);
        if (data?.statusCode === 200) {
          getTotalS3Folders()
          // if (folderData) {
          //   handleAddNewTab(`ile Management`,
          //     "fa-solid fa-desktop",
          //     `fileManagement`,
          //     { ...folderData, name: name, fullPath: `${removeLastFolder(sourceKey?.[0])}${name}/` }
          //   )
          // }
          setName("");
          Hide();
        }
      }
    });
  };

  useEffect(() => {
    if (sourceKey?.length === 1) {
      let keyName = (sourceKey?.[0] || "").split("/").filter(Boolean).pop() || ""
      let nameData = keyName?.split(".")
      setName(nameData?.[0]);
      setExtension(nameData?.[1]);
    }
  }, [sourceKey]);

  return (
    <Modal show={Show} onHide={Hide} placement="end">
      <div ref={ref} className="d-flex flex-column h-100">
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize: 15}}>{Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Folder Name{" "}
              <abbr title="Required" className="text-danger">*</abbr>
            </Form.Label>
            {!extension ?
              <Form.Control
                type="text"
                onChange={(e) => setName(e.target.value)}
                value={name}
                className={`fontSize12 ${name === "Uncategories" ? "border-danger" : ""}`}
                placeholder="Enter Folder Name"
              />
              :
              <InputGroup>
                <Form.Control
                  type="text"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  className={`fontSize12 ${(name === "Uncategories" && !extension) ? "border-danger" : ""}`}
                  placeholder="Enter Folder Name"
                  style={{ borderRadius: "3px 0px 0px 3px" }}
                />
                <InputGroup.Text className="fontSize12 fw-bold">.{extension}</InputGroup.Text>
              </InputGroup>
            }
          </Form.Group>
          {name === "Uncategories" && !extension && (
            <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
              Uncategories name is Default Folder Name, Please Change Name
            </span>
          )}
        </Modal.Body>
        <div className="text-end p-2 border-top">
          <Button
            size="sm"
            variant="outline-primary"
            onClick={updateS3Folder}
            disabled={buttonLoader || !name || (name === "Uncategories" && !extension)}
            title={Title}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Now"
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
});

export default UpdateFolder;